import React, { FC, useMemo } from "react"
import { EventResponse } from "@jnext/ts-axios-eventformat"
import { useTranslation } from "react-i18next"
import './JCardEventTemplate.scss'
import { JCMSStaticCardProps, JCMSStaticCard } from "../../../JCMSStaticSections/components"
import { useJCommonContext } from "../../../JCommonProvider"
import { rewardsToJBadgeItem } from "../../../lib"
import { CMSStaticSection } from "../../../models"
import { EventCategory } from "../../../models/event"
import { JCMSCardProps } from "../../JCMSCard"
import { getEventCommunicationText } from "../../../lib/utils/event"
export interface JCardEventProps extends EventResponse {
    cardProps?: JCMSStaticCardProps
}

export const JCardEvent: FC<JCardEventProps> = ({ cardProps, ...event }) => {
    const { t: translate } = useTranslation();
    const {navigate} = useJCommonContext();
    const options = useMemo(() => (event?.cmsConfig as any)?.options, [event?.cmsConfig]);
    const goToDetail = useMemo(() => options?.goToDetail ?? true, [options])
    
    const section: JCMSCardProps = useMemo(() => (
        eventToSectionCard(event, translate)
    ), [event])

    return (
        <JCMSStaticCard 
            className="jcms-card-event jcms-card-event-template"
            onClick={() => goToDetail && navigate('EVENT_DETAILS', {eventLogicId: event.logicId})}
            {...section} 
            {...(cardProps || {})}
        />
    )
}



export function eventToSectionCard(event: EventResponse, translate: (str: string, params?: Record<string, any>) => string) {
    const _section: JCMSCardProps = {
        enabled: true,
        title: event.cmsConfig?.title,
        text: event.cmsConfig?.shortDescription,
        subTitle: translate('EVENT_TYPE_' + event?.eventType?.typeName).toUpperCase(),
        type: CMSStaticSection.Types.STATIC_CARD,
        options: {
            headerContent: getEventCommunicationText(event, translate)
        }
    }
    if (event.rewards?.length && checkIfRenderBadge(event.eventType?.category) && _section.options) {
        _section.options.walletBadge = rewardsToJBadgeItem(event.rewards)
    }
    if (event.cmsConfig?.baseImage) {
        _section.image = [
            { src: event.cmsConfig?.thumbNailImage || event.cmsConfig?.baseImage }
        ]
    }
    return _section
}


function checkIfRenderBadge(eventCategory: EventCategory | string | undefined) {
    return eventCategory === EventCategory.Core
}
